@if (isLoggedIn() && !isolatePageContent()) {
  <upu-top-bar />
}

<main class="w-full" [class.pb-9]="!isolatePageContent()">
  <router-outlet />
</main>

@if (isLoggedIn() && !isolatePageContent()) {
  <upu-notification-panel />
}
